import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import './css/dorms.css'
import Head from './head';
import Nav from './nav';
import Footer from './footer';
import Scripts from './scripts';
import filterDorms from "./js/filter";

//images for dorm page
import andrews from "./img/outside/andrews.jpg";
import barbour from "./img/outside/barbour.jpg";
import caswell from "./img/outside/caswell.jpg";
import champlin from "./img/outside/champlin.jpg";
import diman from "./img/outside/diman.jpg";
import chapin from "./img/outside/chapin.jpg";
import goddard from "./img/outside/goddard.jpg";
import gradCenter from "./img/outside/gradcenter.jpg";
import greg from "./img/outside/greg.jpg";
import hark from "./img/outside/harkness.jpg";
import heg from "./img/outside/hegeman.jpg";
import hope from "./img/outside/hope.jpg";
import keeney from "./img/outside/keeney.jpg";
import little from "./img/outside/littlefield.jpg";
import marcy from "./img/outside/marcy.jpg";
import met from "./img/outside/metcalf.jpg";
import miller from "./img/outside/miller.jpg";
import minden from "./img/outside/minden.jpg";
import morris from "./img/outside/morris.jpg";
import olney from "./img/outside/olney.jpg";
import pem from "./img/outside/pembroke.jpg";
import perk from "./img/outside/perkins.jpg";
import sears from "./img/outside/sears.jpg";
import slater from "./img/outside/slater.jpg";
import well from "./img/outside/wellness.jpg";
import emery from "./img/outside/emery.jpg";
import woolley from "./img/outside/woolley.jpg";
import buxton from "./img/outside/buxton.jpg";
import wayland from"./img/outside/waylandHouse.jpg";
import youngo from "./img/outside/youngo.jpg";

const LocationPin = () => (
	<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" focusable="false">
		<path d="M10 18s6-5.5 6-10a6 6 0 10-12 0c0 4.5 6 10 6 10z"/>
		<circle cx="10" cy="8" r="2"/>
	</svg>
);

const Check = () => (
	<svg viewBox="0 0 12 12" width="10" height="10" fill="none" stroke="#fff" strokeWidth="2" aria-hidden="true" focusable="false">
		<path d="M2.5 6l2.5 2.5 4.5-5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

function FilterBox({id, name, className, label}) {
	return (
		<label className="filter-box" htmlFor={id}>
			<input id={id} name={name} className={className} type="checkbox" onClick={() => filterDorms()}/>
			<span className="check" aria-hidden="true"><Check/></span>
			{label}
		</label>
	)
}

function DormCard({id, num, img, name, type, location}) {
	return (
		<Link id={id} className="dorm-card" to={`/dorm-listing/${num}`}>
			<div className="card-photo" style={{backgroundImage: `url(${img})`}}>
				<span className="tag">{type}</span>
			</div>
			<div className="card-body">
				<h3>{name}</h3>
				<div className="card-location"><LocationPin/>{location}</div>
			</div>
		</Link>
	)
}

const dormList = [
	{id: "Morris", num: 1, img: morris, name: "Morris Hall", type: "Freshman", location: "North Campus"},
	{id: "Champlin", num: 2, img: champlin, name: "Champlin", type: "Freshman", location: "North Campus"},
	{id: "Emery", num: 3, img: emery, name: "Emery", type: "Freshman", location: "North Campus"},
	{id: "Woolley", num: 4, img: woolley, name: "Woolley Hall", type: "Freshman", location: "North Campus"},
	{id: "Andrews", num: 5, img: andrews, name: "Andrews Hall", type: "Freshman", location: "North Campus"},
	{id: "Metcalf", num: 6, img: met, name: "Metcalf", type: "Freshman", location: "North Campus"},
	{id: "Miller", num: 7, img: miller, name: "Miller Hall", type: "Freshman", location: "North Campus"},
	{id: "Wellness", num: 8, img: well, name: "Wellness", type: "Upperclassman", location: "North Campus"},
	{id: "Slater", num: 9, img: slater, name: "Slater Hall", type: "Upperclassman", location: "Main Campus"},
	{id: "Hope", num: 10, img: hope, name: "Hope College", type: "Upperclassman", location: "Main Campus"},
	{id: "Hegeman", num: 11, img: heg, name: "Hegeman Hall", type: "Upperclassman", location: "Main Campus"},
	{id: "Littlefield", num: 12, img: little, name: "Littlefield Hall", type: "Upperclassman", location: "Main Campus"},
	{id: "Barbour", num: 13, img: barbour, name: "Barbour Hall", type: "Upperclassman", location: "South Campus"},
	{id: "Wayland", num: 14, img: wayland, name: "Wayland House", type: "Upperclassman", location: "South Campus"},
	{id: "Minden", num: 15, img: minden, name: "Minden Hall", type: "Upperclassman", location: "Main Campus"},
	{id: "Goddard", num: 16, img: goddard, name: "Goddard House", type: "Upperclassman", location: "South Campus"},
	{id: "Buxton", num: 17, img: buxton, name: "Buxton House", type: "Upperclassman", location: "South Campus"},
	{id: "Olney", num: 18, img: olney, name: "Olney House", type: "Upperclassman", location: "South Campus"},
	{id: "Harkness", num: 19, img: hark, name: "Harkness House", type: "Upperclassman", location: "South Campus"},
	{id: "Chapin", num: 20, img: chapin, name: "Chapin House", type: "Upperclassman", location: "South Campus"},
	{id: "Diman", num: 21, img: diman, name: "Diman House", type: "Upperclassman", location: "South Campus"},
	{id: "Sears", num: 22, img: sears, name: "Sears House", type: "Upperclassman", location: "South Campus"},
	{id: "Marcy", num: 23, img: marcy, name: "Marcy House", type: "Upperclassman", location: "South Campus"},
	{id: "Caswell", num: 24, img: caswell, name: "Caswell Hall", type: "Upperclassman", location: "Main Campus"},
	{id: "Greg", num: 25, img: greg, name: "Greg", type: "Upperclassman", location: "South Campus"},
	{id: "Keeney", num: 26, img: keeney, name: "Keeney Quad", type: "Freshman", location: "South Campus"},
	{id: "Grad", num: 27, img: gradCenter, name: "Grad Center", type: "Upperclassman", location: "South Campus"},
	{id: "Pembroke", num: 28, img: pem, name: "New Pembroke", type: "Freshman & Upper", location: "North Campus"},
	{id: "Young Orchard", num: 29, img: youngo, name: "Young Orchard", type: "Upperclassman", location: "South Campus"},
	{id: "Perkins", num: 30, img: perk, name: "Perkins Hall", type: "Upperclassman", location: "South Campus"},
];

function Dorms (){
	const [filtersOpen, setFiltersOpen] = useState(false);
	const [search, setSearch] = useState("");

	const visibleDorms = dormList.filter((dorm) => dorm.name.toLowerCase().includes(search.trim().toLowerCase()));

	return (
		<div className="dorms-page">
			<Head/>
			<Nav/>

			<div className="page-header">
				<div>
					<h1>Dorms</h1>
					<p className="page-sub">{dormList.length} residence halls across Brown's campus</p>
				</div>

				<div className="search-box">
					<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="9" cy="9" r="6"/><path d="M17 17l-4-4" strokeLinecap="round"/></svg>
					<input type="text" placeholder="Search dorms..." value={search} onChange={(e) => setSearch(e.target.value)} aria-label="Search dorms by name"/>
				</div>
			</div>

			<div className="dorms-layout">
				<div className="filters">
					<div className="filters-heading">
						<span className="filters-title">Filters</span>
					</div>

					<button type="button" className="filters-toggle" aria-expanded={filtersOpen} aria-controls="filters-body"
						onClick={() => setFiltersOpen(current => !current)}>
						<span>Filters</span>
						<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true" focusable="false"><path d="M5 8l5 5 5-5" strokeLinecap="round" strokeLinejoin="round"/></svg>
					</button>

					<div id="filters-body" className={"filters-body" + (filtersOpen ? " open" : "")}>
						<div>
							<div className="filter-group-heading">Room Type</div>
							<FilterBox id="singles" name="singles" className="room" label="Singles"/>
							<FilterBox id="doubles" name="doubles" className="room" label="Doubles"/>
							<FilterBox id="triples" name="triples" className="room" label="Triples"/>
							<FilterBox id="quads" name="quads" className="room" label="Quads"/>
							<FilterBox id="suite" name="suite" className="room" label="Suites"/>
						</div>

						<div>
							<div className="filter-group-heading">Location</div>
							<FilterBox id="north campus" name="north" className="location" label="North Campus"/>
							<FilterBox id="center campus" name="center" className="location" label="Center Campus"/>
							<FilterBox id="south campus" name="south" className="location" label="South Campus"/>
						</div>

						<div>
							<div className="filter-group-heading">Bathroom</div>
							<FilterBox id="privateBathroom" name="privateBathroom" className="bathroom" label="Private"/>
							<FilterBox id="semiprivateBathroom" name="semiprivateBathroom" className="bathroom" label="Semi Private"/>
							<FilterBox id="communalBathroom" name="communalBathroom" className="bathroom" label="Communal"/>
						</div>

						<div>
							<div className="filter-group-heading">Kitchen</div>
							<FilterBox id="privateKitchen" name="privateKitchen" className="kitchen" label="Private"/>
							<FilterBox id="communalKitchen" name="communalKitchen" className="kitchen" label="Communal"/>
						</div>

						<div>
							<div className="filter-group-heading">Year</div>
							<FilterBox id="freshman housing" name="freshman housing" className="year" label="Freshman"/>
							<FilterBox id="upperclassman housing" name="upperclassman housing" className="year" label="Upperclassman"/>
						</div>

						<div>
							<div className="filter-group-heading">Other</div>
							<FilterBox id="hasElevator" name="hasElevator" className="elevator" label="Elevator"/>
							<FilterBox id="hasCarpet" name="hasCarpet" className="carpet" label="Carpet"/>
							<FilterBox id="hasCommonRoom" name="hasCommonRoom" className="common_room" label="Common Room"/>
						</div>
					</div>
				</div>

				<div>
					<div className="dorms-grid" id="dorms">
						{visibleDorms.map((dorm) => <DormCard key={dorm.id} {...dorm}/>)}
					</div>
					{visibleDorms.length === 0 ? <p className="no-results">No dorms match "{search}".</p> : null}
				</div>
			</div>

			<Footer/>
			<Scripts/>
		</div>
	)
}

export default Dorms;
